import { Zap, Flame } from "lucide-react";

// Icona coerente col tipo fornitura, da affiancare a TIPO_BADGE[..].label
// (le emoji sono state rimosse dalle label in favore di icone lucide).
export function TipoIcon({ tipo }: { tipo: string }) {
  if (tipo === "Luce") return <Zap size={12} />;
  if (tipo === "Gas") return <Flame size={12} />;
  if (tipo === "Dual") return (
    <>
      <Zap size={12} />
      <Flame size={12} />
    </>
  );
  return null;
}
